import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {
	return {
		darkModeBorderBroadcastPlayer: {
			aspectRatio  : theme?.other.isApple ? "unset" : "16/9",
			border       : theme.other.darkMode ? `0.5px solid ${ theme.other.paletteNew.darkModeWhite20 }` : "unset",
			borderRadius : "1rem",
			overflow     : "hidden",

			[rooterMediaQuery.mobile]: {
				borderRadius : "unset",
				border       : "unset"
			}
		},
		darkModeNoBorderRadiusPlayer: {
			border: theme.other.darkMode ? `0.5px solid ${ theme.other.paletteNew.darkModeWhite20 }` : "unset"
		},
		streamDetailsContainer: {
			padding                            : "0 1rem",
			[rooterMediaQuery.mobileAndTablet] : {
				padding: "0.25rem 1.6rem"
			}
		},
		playerContainer: {
			[rooterMediaQuery.mobile]: {
				position : "sticky !important",
				top      : "70px",
				height   : "auto !important",
				zIndex   : 100

			}
		}
	};
} );
